import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { logger } from '../../utils/logger';

const { FiAlertTriangle, FiRefreshCw, FiHome } = FiIcons;

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('React Component Crash', { error: error.toString(), info: errorInfo });
  }

  handleReset() {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center p-8">
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="max-w-xl w-full bg-white/[0.02] border border-white/10 p-12 rounded-[3rem] backdrop-blur-3xl text-center space-y-8"
          >
            <div className="w-24 h-24 bg-rose-500/10 text-rose-500 rounded-3xl flex items-center justify-center mx-auto border border-rose-500/20">
              <SafeIcon icon={FiAlertTriangle} className="text-4xl" />
            </div>
            
            <div className="space-y-2">
              <h1 className="text-3xl font-black text-white uppercase tracking-tight">System Interruption</h1>
              <p className="text-slate-400 font-medium leading-relaxed">
                A critical error occurred in the SessionHQ core. Our monitoring system has captured the trace for immediate analysis.
              </p>
            </div>

            <div className="p-6 bg-black/40 rounded-2xl border border-white/5 text-left font-mono text-[10px] text-rose-400 overflow-x-auto">
              {this.state.error?.toString()}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => window.location.reload()}
                className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all flex items-center justify-center gap-2"
              >
                <SafeIcon icon={FiRefreshCw} /> Reboot Session
              </button>
              <button 
                onClick={this.handleReset}
                className="flex-1 bg-white/5 hover:bg-white/10 text-white py-4 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all flex items-center justify-center gap-2 border border-white/10"
              >
                <SafeIcon icon={FiHome} /> Return to Base
              </button>
            </div>
          </motion.div>
        </div>
      );
    }

    return this.props.children;
  }
}